/**
 * 培训相关API接口
 */
import request from '@/utils/request'
import type {
  TrainingCourse,
  TrainingVideo,
  TrainingDocument,
  TrainingProgress,
  ApiResponse,
  PaginationParams,
  PaginationResponse
} from '@/types/models'

export const trainingApi = {
  /**
   * 获取培训课程列表
   */
  getCourseList(params?: PaginationParams) {
    return request<ApiResponse<PaginationResponse<TrainingCourse>>>({
      url: '/api2/trainings',
      method: 'get',
      params
    })
  },

  /**
   * 获取课程详情
   */
  getCourseDetail(id: string) {
    return request<ApiResponse<TrainingCourse>>({
      url: `/api2/trainings/${id}`,
      method: 'get'
    })
  },

  /**
   * 报名培训课程
   */
  enrollCourse(id: string) {
    return request<ApiResponse<void>>({
      url: `/api2/trainings/${id}/enroll`,
      method: 'post'
    })
  },

  /**
   * 获取我的培训列表
   */
  getMyEnrollments(params?: PaginationParams) {
    return request<ApiResponse<PaginationResponse<any>>>({
      url: '/api2/trainings/my-enrollments',
      method: 'get',
      params
    })
  },

  /**
   * 获取培训进度
   */
  getCourseProgress(id: string) {
    return request<ApiResponse<TrainingProgress>>({
      url: `/api2/trainings/${id}/progress`,
      method: 'get'
    })
  },

  /**
   * 获取视频播放信息
   */
  getVideoInfo(id: string) {
    return request<ApiResponse<TrainingVideo>>({
      url: `/api2/trainings/videos/${id}`,
      method: 'get'
    })
  },

  /**
   * 更新学习进度
   */
  updateProgress(data: {
    videoId: string
    progress: number
    lastPosition: number
    watchTime: number
  }) {
    return request<ApiResponse<TrainingProgress>>({
      url: '/api2/trainings/progress',
      method: 'post',
      data
    })
  },

  /**
   * 获取视频学习进度
   */
  getVideoProgress(videoId: string) {
    return request<ApiResponse<TrainingProgress>>({
      url: `/api2/trainings/progress/${videoId}`,
      method: 'get'
    })
  },

  /**
   * 获取文档列表
   */
  getDocumentList(courseId: string) {
    return request<ApiResponse<TrainingDocument[]>>({
      url: `/api2/trainings/${courseId}/documents`,
      method: 'get'
    })
  },

  /**
   * 下载文档
   */
  downloadDocument(documentId: string) {
    return request<Blob>({
      url: `/api2/trainings/documents/${documentId}/download`,
      method: 'get',
      responseType: 'blob'
    })
  },

  /**
   * 标记课程完成
   */
  completeCourse(courseId: string) {
    return request<ApiResponse<void>>({
      url: `/api2/trainings/${courseId}/complete`,
      method: 'post'
    })
  }
}

export default trainingApi